import React from 'react'
import { useEffect } from 'react'
import { Loading, useTraversal } from '@guillotinaweb/react-gmi'
import { PackForm } from './pack'
import { getState } from '../../pages/product/create-content'

export function ProductForm(props) {
  const { state } = useTraversal()
  const isPack = state.path === '/packs/'

  useEffect(() => {
    if (isPack) return
    const [, setCellar] = getState.cellar()
    setCellar(state.context['@name'])
    window.history.pushState(state, document.title, [
      `/-admin/product/create-content`,
    ])
  }, [isPack])

  if (isPack) return <PackForm {...props} />

  return <Loading />
}
